/* Grid theme for eZdia Highcharts JS
 * @author eZdia
 */

Highcharts.theme = {
    colors: ['#AFCD72', '#468847', '#BACAD1', '#A1BCC9', '#7DA0B3', '#627F8E', '#3a87ad', '#A09993', '#000000', '#C09493', '#b94a48', '#DCB071', '#f89406'],
    chart: {
        backgroundColor: '#fff'
    },
    title: { 
        style: {
            fontWeight: '700',
            letterSpacing: '-0.04em',
            lineHeight: '1.1',
            color: '#3f3f3f',
            fontFamily: '"Lucida Grande","Lucida Sans Unicode","Lucida Sans",Geneva,Verdana,sans-serif'
        }
    },
    subtitle: {
        style: {
            color: '#3f3f3f',
            fill: '#3f3f3f',
            font: 'bold 12px "Helvetica Neue",Helvetica,Arial,sans-serif'
        }
    },
    legend: {
        itemStyle: {
            font: '9pt "Helvetica Neue",Helvetica,Arial,sans-serif',
            color: '#3f3f3f',
            fill: '#3f3f3f'
        },
        itemHoverStyle:{
            color: '#3f3f3f',
            fill: '#3f3f3f',
            font: '9pt "Helvetica Neue",Helvetica,Arial,sans-serif'
        }   
    }
};

// Apply the theme
var highchartsOptions = Highcharts.setOptions(Highcharts.theme);